import script from "./Savings.vue?vue&type=script&lang=ts&setup=true"
export * from "./Savings.vue?vue&type=script&lang=ts&setup=true"

import "./Savings.vue?vue&type=style&index=0&id=155323e4&lang=scss"

const __exports__ = script;

export default __exports__